import { getDatabase, get, ref, set, onValue, query, startAt, orderByChild, push, remove, runTransaction, update, increment } from "firebase/database";
import { getDownloadURL, getStorage, ref as refStorage } from "firebase/storage";
import { getApps, initializeApp } from "firebase/app";
import "firebase/compat/firestore";
import { useEffect, useState } from "react";
import moment from "moment/moment";

const firebaseConfig = {
	apiKey: "AIzaSyAmDgEMVgm-aLKzRhqnihBesbF26BCzhEI",
	authDomain: "sorteig-patum-infantil.firebaseapp.com",
	projectId: "sorteig-patum-infantil",
	storageBucket: "sorteig-patum-infantil.appspot.com",
	messagingSenderId: "391797776705",
	appId: "1:391797776705:web:1ca253541a2c2ec7cec1c0",
	databaseURL: "https://sorteig-patum-infantil-default-rtdb.europe-west1.firebasedatabase.app",
};

let app;
if (!getApps().length) {
	app = initializeApp(firebaseConfig);
}

const database = getDatabase(app);
const storage = getStorage(app);

// Inscrits
function Inscrits() {
	const [inscrits, setInscrits] = useState(null);
	const [loadingI, setLoading] = useState(true);
	const [errorI, setError] = useState(null);

	const getInscrits = async () => {
		setInscrits([]);
		try {
			const dataRef = ref(database, "inscrits");
			onValue(dataRef, (snapshot) => {
				const ins = [];
				let i = 1;
				snapshot.forEach((item) => {
					ins.push({
						index: i,
						id: item.key,
						data_n_nen: item.val().data_n_nen,
						nom_nen: item.val().nom_nen,
						cognoms_nen: item.val().cognoms_nen,
						dni_nen: item.val().dni_nen,
						nom: item.val().nom,
						cognoms: item.val().cognoms,
						dni: item.val().dni,
						telefon: item.val().telefon,
						email: item.val().email,
						data_n: item.val().data_n,
						comparses: item.val().comparses,
						nom_acompanyant: item.val().nom_acompanyant,
						cognoms_acompanyant: item.val().cognoms_acompanyant,
						alcada: item.val().alcada,
						dni_acompanyant: item.val().dni_acompanyant,
						data_n_acompanyant: item.val().data_n_acompanyant,
					});
					i++;
				});
				setInscrits(ins);
				setLoading(false);
			});
		} catch (e) {
			console.log(e);
			setError(e);
		}
	};

	const removeInscrit = async (ins) => {
		remove(ref(database, "inscrits/" + ins));
	};

	const addInscrit = (ins) => {
		push(ref(database, "inscrits"), {
			...ins,
		});
	};

	return [loadingI, errorI, inscrits, getInscrits, addInscrit, removeInscrit];
}

// Opcions
function Opcions() {
	const [opcions, setOpcions] = useState(null);
	const [loadingO, setLoading] = useState(true);
	const [errorO, setError] = useState(null);

	const getOpcions = async () => {
		setOpcions([]);
		try {
			const dataRef = ref(database, "opcions");
			onValue(dataRef, (snapshot) => {
				setOpcions(snapshot.val());
				setLoading(false);
			});
		} catch (e) {
			console.log(e);
			setError(e);
		}
	};

	const editarOpcions = async (opcio, valor) => {
		const updates = {};
		updates["opcions/" + opcio] = valor;

		update(ref(database), updates);
	};

	return [loadingO, errorO, opcions, getOpcions, editarOpcions];
}

// Temps
function Temps() {
	const [temps, setTemps] = useState(null);

	const getTemps = async () => {
		try {
			const dataRef = ref(database, "temps");
			onValue(dataRef, (snapshot) => {
				setTemps(snapshot?.val());
			});
		} catch (e) {
			console.log(e);
		}
	};

	const addMinuts = async (minutes) => {
		try {
			const dataRef = ref(database, "temps");
			runTransaction(dataRef, (temps) => {
				let result;
				if (minutes >= 0) {
					result = moment(temps).add("minutes", minutes).format("YYYY-MM-DD HH:mm");
				} else {
					result = moment(temps).subtract("minutes", Math.abs(minutes)).format("YYYY-MM-DD HH:mm");
				}
				return result;
			});
		} catch (e) {
			console.log(e);
		}
	};

	return [temps, getTemps, addMinuts];
}

// Inscrits
function Finals() {
	const [finals, setFinals] = useState(null);
	const [loadingF, setLoading] = useState(true);
	const [errorF, setError] = useState(null);

	const getFinals = async () => {
		setFinals([]);
		try {
			const dataRef = ref(database, "finals");
			onValue(dataRef, (snapshot) => {
				const ins = [];
				snapshot.forEach((item) => {
					ins.push({
						id: item.val().id,
						llista: item.val().llista,
					});
				});
				setFinals(ins?.reverse());
				setLoading(false);
			});
		} catch (e) {
			console.log(e);
			setError(e);
		}
	};

	const removeFinals = async () => {
		remove(ref(database, "finals"));
	};

	const removeInscrits = async () => {
		remove(ref(database, "inscrits"));
	};

	const addFinals = (fi) => {
		set(ref(database, "finals"), {
			...fi,
		});
	};

	return [loadingF, errorF, finals, getFinals, addFinals, removeFinals, removeInscrits];
}

export { database, storage, Inscrits, Opcions, Temps, Finals };
